module.exports = __webpack_public_path__ + "static/media/TUNE_5063.9608e04b.jpg";